import React from 'react';
const facts = [{
  value: '124',
  label: 'Field Procedure Cards'
}, {
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '38',
  label: 'Ready-to-use worksheets'
}, {
  value: '4',
  label: 'Systems: water, refrig, harvest, controls'
}];

// Colores de sistema del producto
const accents = ['before:bg-sys-water', 'before:bg-sys-refrig', 'before:bg-sys-harvest', 'before:bg-sys-controls'];
export function SocialProofBar() {
  return <section className="w-full bg-forest-deep" data-id="element-341" data-mp="32h0iodkpba50">
      <div className="mx-auto max-w-6xl px-5 pb-12 sm:pb-16" data-id="element-342" data-mp="2xjryk7fzsw14">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-forest-line bg-forest-line sm:grid-cols-4" data-id="element-343" data-mp="2xi76qpl2br6y">
          {facts.map((fact, i) => <div key={fact.label} className={`relative bg-forest-deep px-4 py-5 text-center before:absolute before:inset-x-0 before:top-0 before:h-1 before:content-[''] ${accents[i]}`} data-id="element-344" data-mp="2oj271fxrlrt7" data-mpi={i}>
              <div className="font-mono text-3xl font-bold leading-none text-ember sm:text-4xl" data-id="element-345" data-mp="1d6j61uxufejw">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-paper/65" data-id="element-346" data-mp="1dmcp56q5ykev">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}